module.exports = require("koishi");